import type { SiteName } from '@/scopes/common/domain/types';

export default function showWeeks(siteName: SiteName) {
  return siteName === 'sunwebdk' || siteName === 'sunwebse' || siteName === 'sunwebnl' || siteName === 'sunwebde';
}
